// @flow
/** @jsx h */
import { Fragment, h } from 'preact';
import MobileVerification from './common/MobileVerification';
import ShowInterstitialMsg from './common/ShowInterstitialMsg';
import ShareNtbAppContainer from './common/ShareNtbAppContainer';
import EnterAmount from './common/EnterAmount';
import AmountNotMatchError from './common/AmountNotMatchError';
import {
  useSalesContext,
  useSalesDispatchContext,
} from '../../storeProviders/salesAppStore';
import OverlayBottomSheet from './OverlayBottomSheet';
import {
  mobileVerificationOverLayHeight,
  shareNtbAppOverLayHeight,
  enterAmountOverLayHeight,
  custPreApprovalMsgOverLayHeight,
} from './constants';
import ErrorContent from './ErrorContent';
import SaShareInfoSheet from './SaShareInfoSheet';
import { useErrorModalContextDispatch } from '../../storeProviders/errorModalStore';
import { useSalesAppTracker } from './tracker';
import UserEligibilityInfo from './common/UserEligibilityInfo';

const RenderBottomSheet = () => {
  const salesState = useSalesContext();
  const salesDispatch = useSalesDispatchContext();
  const errorModalDispatch = useErrorModalContextDispatch();
  const salesAppTracker = useSalesAppTracker();
  const {
    bottomSheetConfig,
    showInterstitial,
    routeDetails,
    merchantData,
    selectedLenderId,
  } = salesState;
  const { path } = routeDetails;
  const { type } = merchantData || {};

  const closeIframe = () => {
    salesDispatch({
      type: 'SEND_MESSAGE',
      payload: {
        actionName: 'closeSAApp',
        payload: {},
      },
    });
  };

  const renderModule = (module) => {
    switch (module) {
      case 'MOBILE_VERIFICATION':
        return {
          closeHandler: () => {
            path === '/sales-app-init' && type !== 'EMI_HOME'
              ? closeIframe()
              : salesDispatch({
                  type: 'STORE_STATE',
                  payload: {
                    bottomSheetConfig: {
                      showOverlay: false,
                      moduleName: null,
                      overlayHeight: mobileVerificationOverLayHeight,
                    },
                  },
                });
          },
          moduleComponent: <MobileVerification />,
        };
      case 'SHOW_INTERSTITIAL_MSG':
        return {
          closeHandler: () => {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                showInterstitial: false,
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                  overlayHeight: custPreApprovalMsgOverLayHeight,
                },
              },
            });
          },
          moduleComponent: <ShowInterstitialMsg />,
        };
      case 'SHARE_NTB_APP':
        return {
          closeHandler: () => {
            salesAppTracker.trackClick(
              'sa_click_close_ntb_share_details',
              undefined,
            );
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                  overlayHeight: shareNtbAppOverLayHeight,
                },
              },
            });
          },
          moduleComponent: <ShareNtbAppContainer />,
        };
      case 'AMOUNT':
        return {
          closeHandler: () => {
            path === '/sales-app-init' && type !== 'EMI_HOME'
              ? closeIframe()
              : salesDispatch({
                  type: 'STORE_STATE',
                  payload: {
                    selectedLenderId:
                      path === '/sales-lenders-list' ? null : selectedLenderId,
                    bottomSheetConfig: {
                      showOverlay: false,
                      moduleName: null,
                      overlayHeight: enterAmountOverLayHeight,
                    },
                  },
                });
          },
          moduleComponent: <EnterAmount />,
        };
      case 'MIN_AMOUNT_NOT_MATCH':
        return {
          closeHandler: () => {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                selectedLenderId:
                  path === '/sales-lenders-list' ? null : selectedLenderId,
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                },
              },
            });
          },
          moduleComponent: <AmountNotMatchError />,
        };
      case 'ERROR':
        return {
          closeHandler: () => {
            errorModalDispatch({
              type: 'MODAL/CLOSE',
            });
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                },
              },
            });
          },
          moduleComponent: <ErrorContent />,
        };
      case 'SA_SHARE_INFO':
        return {
          closeHandler: () => {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                },
              },
            });
          },
          moduleComponent: <SaShareInfoSheet />,
        };
      case 'USER_ELIGIBILITY_INFO':
        return {
          closeHandler: () => {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: false,
                  moduleName: null,
                },
                bottomSheetData: {
                  mainTitle: null,
                  subTitle: null,
                  primaryText: null,
                  secondaryText: null,
                  btnName: null,
                  textColor: null,
                },
              },
            });
          },
          moduleComponent: <UserEligibilityInfo />,
        };
      default:
        return {
          closeHandler: () => {
            salesDispatch({
              type: 'STORE_STATE',
              payload: {
                bottomSheetConfig: {
                  showOverlay: false,
                },
              },
            });
          },
          moduleComponent: null,
        };
    }
  };

  return (
    <Fragment>
      {bottomSheetConfig.showOverlay && (
        <OverlayBottomSheet
          handleCloseOverlay={
            renderModule(bottomSheetConfig.moduleName).closeHandler
          }
          showOverlay={bottomSheetConfig.showOverlay}
          maxOverlayHeight={bottomSheetConfig.overlayHeight}>
          {renderModule(bottomSheetConfig.moduleName).moduleComponent}
        </OverlayBottomSheet>
      )}
    </Fragment>
  );
};

export default RenderBottomSheet;



// WEBPACK FOOTER //
// ./components/salesApp/RenderBottomSheet.js